import React from 'react';
import { useRBAC } from '../../context/RBACContext';

/**
 * ProtectedButton
 * Props:
 * - permission: single permission string
 * - permissions: array (ALL required)
 * - anyPermissions: array (ANY required)
 * - roles: array of roles allowed
 * - disabledFallback: whether to render disabled button when not allowed (default true)
 * - children: button contents
 * - ...rest: passed to button
 */
const ProtectedButton = ({
  permission,
  permissions,
  anyPermissions,
  roles,
  disabledFallback = true,
  children,
  ...rest
}) => {
  const { hasPermission, hasAllPermissions, hasAnyPermission, hasAnyRole } = useRBAC();

  let allowed = true;

  if (permission) allowed = allowed && hasPermission(permission);
  if (permissions && Array.isArray(permissions)) allowed = allowed && hasAllPermissions(permissions);
  if (anyPermissions && Array.isArray(anyPermissions)) allowed = allowed && hasAnyPermission(anyPermissions);
  if (roles && Array.isArray(roles)) allowed = allowed && hasAnyRole(roles);

  if (allowed) {
    return (
      <button {...rest}>
        {children}
      </button>
    );
  }

  if (disabledFallback) {
    return (
      <button {...rest} disabled title="You don't have permission to perform this action">
        {children}
      </button>
    );
  }

  return null;
};

export default ProtectedButton;
